import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: theme.spacing(2),
    },
    boxGroupTitle: {},

    expandButton: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      justifyContent: 'left',
      width: 'fit-content',
    },

    externalLinkIcon: {
      fontSize: theme.typography.pxToRem(12),
      margin: theme.spacing(0.25),
    },

    externalLink: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
    },

    detectedBrandTerm: {
      '& + &': {
        marginTop: theme.spacing(2),
      },
    },

    collapseWrapperInner: {
      gap: 0,
      paddingTop: 0,
    },
  }),
  { name: 'BrandTerms' }
);
